module.exports = __webpack_public_path__ + "static/media/seguros-mundial-survey-provider.24a78ca9.svg";